export default __webpack_public_path__ + "082058530169595883801963a32c7173.svg";